module.exports = __webpack_public_path__ + "img/friend.b014072f.svg";